import { render, staticRenderFns } from "./GraficoBarra.vue?vue&type=template&id=03a7f965&"
import script from "./GraficoBarra.vue?vue&type=script&lang=ts&"
export * from "./GraficoBarra.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports